"use strict";

exports.__esModule = true;
exports.openFilter = openFilter;
exports.closeFilter = closeFilter;
exports.clearFilter = clearFilter;
exports.setFilterSortField = setFilterSortField;
exports.setFilterSortOrientation = setFilterSortOrientation;
exports.addFilterQuery = addFilterQuery;
exports.setSearch = setSearch;
exports.editFilterQuery = editFilterQuery;
exports.removeFilterQuery = removeFilterQuery;

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function openFilter(name) {
  return {
    type: types.ON_FILTER_IS_OPEN,
    name: name,
    payload: {
      isOpen: true
    }
  };
}

function closeFilter(name) {
  return {
    type: types.ON_FILTER_IS_CLOSE,
    name: name,
    payload: {
      isOpen: false
    }
  };
}

function clearFilter(name) {
  return {
    type: types.ON_CLEAR,
    name: name
  };
}

function setFilterSortField(name, sortField) {
  return {
    type: types.ON_FILTER_SORT_FIELD_CHANGED,
    name: name,
    payload: {
      sortField: sortField
    }
  };
}

function setFilterSortOrientation(name, sortOrientation) {
  return {
    type: types.ON_FILTER_SORT_FIELD_CHANGED,
    name: name,
    payload: {
      sortOrientation: sortOrientation
    }
  };
}

function addFilterQuery(name, query) {
  return {
    type: types.ON_ADD_FILTER_QUERY,
    name: name,
    payload: _extends({}, query)
  };
}

function setSearch(name, search) {
  return {
    type: types.ON_SET_SEARCH,
    name: name,
    payload: search
  };
}

function editFilterQuery(name, index, query) {
  return {
    type: types.ON_EDIT_FILTER_QUERY,
    name: name,
    index: index,
    payload: _extends({}, query)
  };
}

function removeFilterQuery(name, index) {
  return {
    type: types.ON_REMOVE_FILTER_QUERY,
    name: name,
    index: index
  };
}